export default __webpack_public_path__ + "static/media/defaultImage.6305cd34.jpg";